import Stack from '@mui/material/Stack';
import { useForm } from 'react-hook-form';

import { GeographicScopeFields } from '@/components/form/GeographicScopeFields';

import { State } from '../State';

interface SampleScope {
  scope: string;
  states: string[];
  note: string;
}

export function GeographicScopeFieldsExamples() {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useForm<SampleScope>({
    defaultValues: { scope: 'MULTI_STATE', states: ['MD', 'VA'], note: '' },
  });

  return (
    <State
      title="Scope, states and a note"
      note="The states box appears when the chosen scope needs states named."
    >
      <Stack spacing={2.5} sx={{ maxWidth: 560 }}>
        <GeographicScopeFields
          names={{ scope: 'scope', states: 'states', note: 'note' }}
          control={control}
          register={register}
          watch={watch}
          errors={errors}
          testId="gallery-geographic-scope-fields"
        />
      </Stack>
    </State>
  );
}
